import React from 'react'
import "./work.css"
import Works from './Works';
import { motion } from "framer-motion";

const Work = () => {
    return (
        <section className='work section' id='portfolio'>
            <h2 className='section__title'>Portfolio</h2>

            <span className='section__subtitle'>
                Most Recent Works
            </span>
                <motion.div
      animate={{
        scale: [2, 1],
        rotate: [90, 0],
      }}
      transition={{
        duration: 0.5,
        ease: "easeInOut",
      }}
      className="projects"
    >
            <Works />
            </motion.div>
        </section>
    );
};

export default Work;